import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { AddBillingitemTopackageWizardEffects } from './effects';
import * as fromAddBillingitemTopackageWizard from './reducer';

export function provideAddBillingitemTopackageWizardStoreV26(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(fromAddBillingitemTopackageWizard.addBillingitemTopackageWizardFeatureKey, fromAddBillingitemTopackageWizard.reducer),
    provideEffects(AddBillingitemTopackageWizardEffects),
  ]);
}
